// A title belongs to the governed patient identity, not a guessed name prefix.
// Use the recorded family name for the short clinical address (e.g. Mr. Ndlovu).
export function formatInstitutionPatientAddress(patient = {}) {
  const title = String(patient.title || patient.patient_title || "").trim();
  const lastName = String(patient.lastName || patient.patient_last_name || "").trim();
  if (title && lastName) return `${title.replace(/\.$/, "")}. ${lastName}`;
  return String(patient.fullName || patient.patient_name || "Patient").trim();
}
